import React from 'react'
import { CustomTable } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { parcelResponseListColumns } from 'src/core/table-columns'
import { getCsvFromObjectArray, downloadCsv, getActualDateFormated } from 'src/core/helpers'
import ResponseListHeader from '../ResponseListHeader/ResponseListHeader'


const CarsCalculateResponseList = ({ loading }) => {
  const { data } = useAppSelector((state) => state.admin.massiveCalculation.responseCalculate)
  const excelData = useAppSelector((state) => state.admin.massiveCalculation.excelData)

  const getvalue = (record: any) => {
    const kco2 = record?.response?.result?.value
    return  kco2 ? kco2 : 0
  }

  const handleCsvDownload = () => {
    const results = excelData.map((dataItem, idx) => {
      return {
        ...dataItem,
        kg_co2: getvalue(data[idx])
      }
    })
    const csv = getCsvFromObjectArray(results)
    const csvFileName = `${getActualDateFormated()}__parcel`
    downloadCsv(csv, csvFileName)
  }

  return (
    <>
      {/* Header Content */}
      <ResponseListHeader
        loading={loading}
        length={data?.length}
        handleCsvDownload={handleCsvDownload}
      />
      {/* Table Results */}
      <CustomTable
        columns={parcelResponseListColumns}
        dataSource={data}
      />
    </>
  )
}

export default CarsCalculateResponseList
